import { useAccountSession } from '../../auth/AccountSessionProvider';
import { useI18n } from '../../i18n/useI18n';
import { Alert } from '../../ui/Alert';
import { NoticeScreen } from '../../ui/AuthLayout';
import { Button } from '../../ui/primitives';

/**
 * Signed in, and this console does not know what to draw.
 *
 * Every role the control plane has today opens something, so this is not the
 * "no rights" state — it is the state of a console meeting a role that was
 * added after it was built. Saying so is better than either extreme: an empty
 * shell would look broken, and guessing at the nearest known role would show
 * controls that are refused.
 */
export function AccountNoAccessScreen() {
  const { t } = useI18n();
  const { session, signOut } = useAccountSession();

  return (
    <NoticeScreen>
      <Alert tone="deny" title={t('unknownRole.title')} live>
        <p>{t('unknownRole.body')}</p>
        {session !== null && (
          <>
            <p style={{ marginTop: 8 }}>{t('unknownRole.account', { email: session.actor.email })}</p>
            <p className="mono" style={{ marginTop: 8 }}>
              {session.role}
            </p>
          </>
        )}
      </Alert>

      <div style={{ marginTop: 22 }}>
        <Button
          variant="ghost"
          block
          onClick={() => {
            void signOut();
          }}
        >
          {t('common.signOut')}
        </Button>
      </div>
    </NoticeScreen>
  );
}
